module.exports = __webpack_public_path__ + "img/document.b8b2657f.svg";